"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconForThermalPowerPlants = function IconForThermalPowerPlants(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 5v15.958c5.186.938 9.12 5.476 9.12 10.932 0 6.136-4.974 11.11-11.11 11.11-3.431 0-6.5-1.556-8.537-4H8v-2h13.142a11.06 11.06 0 0 1-1.242-5.11c0-6.132 4.969-11.105 11.1-11.11V7H12v3h14v1H12v14.58c0 2.234-.914 5.053-2.444 8.173l-.213.427-1.786-.9c1.461-2.9 2.362-5.519 2.438-7.442L10 25.58V5zm11 7v12h-2V14h-7v-2zM23 43v-2H12v2zm17.12-11.11a9.11 9.11 0 1 0-18.22 0 9.11 9.11 0 0 0 18.22 0m-12.052-3.354-.636-.772-.147.129a3.28 3.28 0 0 0-.561 4.117l.278.427.102.167a2.28 2.28 0 0 1-.335 2.7l.722.691.138-.152a3.28 3.28 0 0 0 .22-3.937l-.231-.353-.102-.167a2.28 2.28 0 0 1 .552-2.85m3.054-.772.636.772a2.28 2.28 0 0 0-.552 2.85l.102.167.232.353c.05.078.086.137.125.208a3.28 3.28 0 0 1-.346 3.729l-.138.152-.723-.69a2.28 2.28 0 0 0 .336-2.7l-.102-.168-.279-.427-.082-.14a3.28 3.28 0 0 1 .644-3.977zm4.316.772-.636-.772-.147.129a3.28 3.28 0 0 0-.562 4.117l.28.427.1.167a2.28 2.28 0 0 1-.334 2.7l.722.691.138-.152a3.28 3.28 0 0 0 .22-3.937l-.231-.353-.102-.167a2.28 2.28 0 0 1 .552-2.85",
    clipRule: "evenodd"
  })));
};

export { IconForThermalPowerPlants, IconForThermalPowerPlants as default };
